import { render, staticRenderFns } from "./ChildTab.vue?vue&type=template&id=09fc7b71"
import script from "./ChildTab.vue?vue&type=script&lang=js"
export * from "./ChildTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports